import { withPrefix } from "gatsby"
import { Card, Grid } from "@fastly/consistently"
import { MikanSpan } from "../Mikan"

const OSSCards = ({ content }) => {
  return (
    <Grid md={2} lg={3} pt="lg">
      {content.customers.map((customer) => (
        <Card
          key={customer.name}
          link={withPrefix(customer.url)}
          image={customer.logo.file.url}
          type="paddedImage"
          summary={<MikanSpan text={customer.caseStudyTeaser.caseStudyTeaser} />}
        />
      ))}
    </Grid>
  )
}

export default OSSCards
